import { Dialog } from "@/Components";
import React, { useCallback } from "react";
import { toast } from "react-toastify";
import { Inertia } from "@inertiajs/inertia";
import { showToast } from "@/Utilities/Utilities";
import { PropTypes } from "prop-types";

const ClientDialogCenter = ({
  organization,
  showDeleteModal,
  setShowDeleteModal,
  setShowInactivateModal,
  showInactivateModal,
}) => {
  const handleDelete = () => {
    const id = toast.loading("Please wait...");

    Inertia.delete(route("agency.clients.destroy", organization.id), {
      onSuccess: () =>
        showToast(id, `${organization.name} was successfully deleted`),
      onError: () =>
        showToast(
          id,
          `Something went wrong when deleting ${organization.name}`,
          "error",
        ),
    });
  };

  const handleLock = useCallback(() => {
    const id = toast.loading("Please wait...");
    Inertia.put(route("agency.clients.lock", organization.id), null, {
      onSuccess: () => {
        showToast(id, "The client was successfully inactivated");
        setShowInactivateModal(false);
      },
      onError: () =>
        showToast(
          id,
          "Something went wrong when inactivating your client",
          "error",
        ),
    });
  }, [organization.id]);

  return (
    <>
      {showDeleteModal && (
        <Dialog
          openModal={showDeleteModal}
          closeModal={() => setShowDeleteModal(false)}
          modalStyle="popup"
          animation="fade-in"
          tag="Delete client"
          tagStyle="bg-[#FEE5E5]"
          title={`You're about the delete ${organization.name} from Emma`}
        >
          <p>
            This action is permanent and cannot be undone, are you sure you want
            to delete {organization.name}?
          </p>

          <div className="flex w-full items-center justify-end ">
            <a
              className="cursor-pointer py-2 text-blue underline"
              onClick={() => setShowDeleteModal(false)}
            >
              Never mind
            </a>

            <button
              className="btn-red ml-3 grow-0 self-end"
              onClick={handleDelete}
              type="button"
            >
              Delete client
            </button>
          </div>
        </Dialog>
      )}

      {showInactivateModal && (
        <Dialog
          openModal={showInactivateModal}
          closeModal={() => setShowInactivateModal(false)}
          modalStyle="popup"
          animation="fade-in"
          tag="Inactivate client"
          tagStyle="bg-[#FEE5E5]"
          title={`You're about the inactivate ${organization.name} from Emma`}
        >
          <p>
            Your client will no longer be able to access Emma, you can
            reactivate them again later
          </p>

          <div className="flex w-full items-center justify-end ">
            <a
              className="cursor-pointer py-2 text-blue underline"
              onClick={() => setShowInactivateModal(false)}
            >
              Never mind
            </a>

            <button
              className="btn-blue ml-3 grow-0 self-end"
              onClick={handleLock}
              type="button"
            >
              Inactivate client
            </button>
          </div>
        </Dialog>
      )}
    </>
  );
};

ClientDialogCenter.propTypes = {
  organization: PropTypes.object,
  showDeleteModal: PropTypes.bool,
  setShowDeleteModal: PropTypes.func,
  showInactivateModal: PropTypes.bool,
  setShowInactivateModal: PropTypes.func,
};

export default ClientDialogCenter;
